import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import ReactGA from 'react-ga4'
import config from '@configs'

const RouteChangeTracker = () => {
	const location = useLocation()
	const [initialized, setInitialized] = useState(false)

	useEffect(() => {
		if (config.get('isDevEnv') && process.env.REACT_APP_GOOGLE_ANALYTICS) {
			ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS)
			setInitialized(true)
		}
	}, [])

	useEffect(() => {
		if (initialized) {
			ReactGA.set({ page: location.pathname })
			ReactGA.send('pageview')
		}
	}, [initialized, location])
}

export default RouteChangeTracker
